export enum StatoSpedizione {
  DA_RILASCIARE = 0,
  RILASCIATE = 1,
  PRELEVATI = 2,
  IN_SPEDIZIONE = 3,
  SPEDITI = 4
}

export const STATO_SPEDIZIONE = [
  { value: StatoSpedizione.DA_RILASCIARE, label: 'Da rilasciare' },
  { value: StatoSpedizione.RILASCIATE, label: 'Rilasciate' },
  { value: StatoSpedizione.PRELEVATI, label: 'Prelevati' },
  { value: StatoSpedizione.IN_SPEDIZIONE, label: 'In spedizione' },
  { value: StatoSpedizione.SPEDITI, label: 'Spediti' }
];
